import utils from 'lib/utils';
import Backbone from 'backbone';
import EF from 'ef/ef';

const CustomizationService = function () {
  this.typeMapping = {
    'text-content-customization': {
      customization_type: 'text',
      fieldMapping: {
        custom_text: 'text',
      },
    },
    'video-content-customization': {
      customization_type: 'video',
      fieldMapping: {
        video_id: 'youtube_url',
      },
      fieldValues: {
        provider: 'youtube',
      },
    },
    'image-content-customization': {
      customization_type: 'image',
    },
    'page-content-customization': {
      customization_type: 'page',
    },
    'data-option': {
      customization_type: 'data_option',
    },
  };

  this.load = function () {
    return utils.failProofPromise(
      EF.customizations.fetch({
        parse: true,
        headers: { Authorization: `Bearer ${EF.config.get('jwt')}` },
      })
    );
  };

  this.getCustomizationCollectionUrl = function (self, ef) {
    // why one uses ef as a param and other from imported EF ????
    return `${ef.config.get('portalBasePath')}/customizations.json?filter[content_id]=${EF.enrollment.get(
      'contentId'
    )}`;
  };

  this.parseCustomizationCollection = function (response, _options) {
    return utils.sanifyJsonApiObject(response.data, response.included);
  };

  this.getById = function (customizationCollection, id) {
    return Backbone.Collection.prototype.get.call(customizationCollection, id);
  };

  this.findByType = function (customizationCollection, type) {
    const typeMap = this.typeMapping[type];
    const typeValue = (typeMap && typeMap.customization_type) || type;
    return customizationCollection.findWhere(customization => customization.get('customization_type') === typeValue);
  };

  this.getCustomizationByKeyAndSlug = function (customizationCollection, type, slug) {
    const typeMap = this.typeMapping[type];
    const customizations = customizationCollection.filter(customization => {
      // typeMap.customization_type will crash since typeMap can be undefined
      return (
        customization.get('customization_type') === typeMap.customization_type && customization.get('slug') === slug
      );
    });
    // what if there are many more ??
    if (customizations[0]) {
      const customization = customizations[0].toJSON();
      if (typeMap.fieldMapping) {
        Object.entries(typeMap.fieldMapping).forEach(([key, value]) => {
          customization[key] = customization[value];
        });
      }
      if (typeMap.fieldValues) {
        Object.entries(typeMap.fieldValues).forEach(([key, value]) => {
          if (!customization[key]) {
            if (key === 'provider' && type === 'video-content-customization') {
              const VIMEO_REGEX =
                /(?:http|https)?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|)(\d+)(?:|\/\?)/;
              customization[key] = VIMEO_REGEX.test(customization.video_url) ? 'vimeo' : 'youtube';
            } else {
              customization[key] = value;
            }
          }
        });
      }
      return customization;
    }
  };

  this.getByKeyAndPage = function (customizationCollection, type, moduleKey, activityKey, pageKey) {
    const typeMap = this.typeMapping[type];
    const customizations = customizationCollection.filter(customization => {
      return customization.get('customization_type') === typeMap.customization_type;
    });
    const moduleDefault = customizations.find(
      customization => customization.get('data').module_key === moduleKey && !customization.get('data').activity_key
    );
    return customizations.reduce((results, c) => {
      const data = c.get('data');
      if (data.module_key === moduleKey && data.activity_key === activityKey && data.page_key === pageKey) {
        results.push({
          content_type: data.content_type,
          // why the need to check against a string?
          content: data.use_module_default === 'true' ? moduleDefault.get('text') : c.get('text'),
        });
      }
      return results;
    }, []);
  };
};

export default new CustomizationService();
